module.exports = "/legacy/23215a731fdb189ae7b2edf4c16c226d.svg";